import { useState, useCallback } from 'react';
import { showToast } from '@attentive-platform/stem-ui';
import { fetchApiData } from '../Utils/ApiCalls';
import { GET_COMPANY_TRADES } from '../urls';
import { convertTradePayloadToItem } from '../Utils/HelperFunctions';
import { isValidEmail } from '../Utils/HelperFunctions';

export const useGetCompanyTradeData = ({ onTradeDataChange, onFetchApiData }) => {
  const [loading, setLoading] = useState(false);

  const handleApiResponse = useCallback(
    response => {
      const data = response?.trade_configs?.map(item => convertTradePayloadToItem(item)) || [];
      onTradeDataChange(data);
      onFetchApiData?.(response?.trade_configs || []);
    },
    [onTradeDataChange, onFetchApiData]
  );

  const getCompanyTradesData = useCallback(
    async email => {
      if (!email || !isValidEmail(email)) {
        showToast('Please enter a valid email', 'error');
        return;
      }

      try {
        setLoading(true);
        const response = await fetchApiData({
          endpoint: GET_COMPANY_TRADES,
          apiRequest: 'GET',
          params: { email }
        });

        if (response.error) {
          throw new Error(response.error);
        }

        if (response.data) {
          handleApiResponse(response.data);
        }
      } catch (error) {
        showToast(error.message, 'error');
        handleApiResponse({});
      } finally {
        setLoading(false);
      }
    },
    [handleApiResponse]
  );

  return { loading, fetchCompanyTrades: getCompanyTradesData };
};
